"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cartao = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Cartao =
/*#__PURE__*/
function (_Component) {
  _inherits(Cartao, _Component);

  function Cartao(props) {
    var _this;

    _classCallCheck(this, Cartao);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cartao).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "abrirCartao", function () {
      if (!_this.state.estaAberto) {
        if (_this.props.eventoDoBotaoDeExpansaoAoAbrirCartao) {
          _this.props.eventoDoBotaoDeExpansaoAoAbrirCartao();
        }
      }

      _this.setState(function (state) {
        return {
          estaAberto: !state.estaAberto
        };
      });
    });

    _this.state = {
      estaAberto: props.estaAberto || false
    };
    return _this;
  }

  _createClass(Cartao, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          titulo = _this$props.titulo,
          subtitulo = _this$props.subtitulo,
          cor = _this$props.cor,
          icone = _this$props.icone,
          comDestaque = _this$props.comDestaque,
          comConteudoExpansivo = _this$props.comConteudoExpansivo,
          comCabecalhoResponsivo = _this$props.comCabecalhoResponsivo,
          classNameDoBotaoDeExpansao = _this$props.classNameDoBotaoDeExpansao,
          textoDoBotaoDeExpansaoFechado = _this$props.textoDoBotaoDeExpansaoFechado,
          textoDoBotaoDeExpansaoAberto = _this$props.textoDoBotaoDeExpansaoAberto,
          containerSecundario = _this$props.containerSecundario,
          children = _this$props.children,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;
      return _react.default.createElement("section", {
        className: "cartao \n        ".concat(cor ? 'cartao_cor-' + cor : '', "\n        ").concat(comDestaque ? 'cartao_com-destaque' : '', "\n        ").concat(comConteudoExpansivo ? 'cartao_expansivel' : '', "\n        ").concat(comConteudoExpansivo && this.state.estaAberto ? 'cartao_aberto' : '', "\n        ").concat(comCabecalhoResponsivo ? 'cartao_com-cabecalho-centralizado-no-celular' : '', "\n        ").concat(className)
      }, _react.default.createElement("header", {
        className: "cartao__cabecalho"
      }, icone && _react.default.createElement("i", {
        className: "cartao__icone ".concat(icone)
      }), _react.default.createElement("div", {
        className: "cartao__container-primario"
      }, titulo && _react.default.createElement("h2", {
        className: "cartao__titulo"
      }, titulo), subtitulo && _react.default.createElement("p", {
        className: "cartao__subtitulo"
      }, subtitulo)), _react.default.createElement("div", {
        className: "cartao__container-secundario"
      }, containerSecundario, comConteudoExpansivo && _react.default.createElement("button", {
        onClick: this.abrirCartao,
        className: classNameDoBotaoDeExpansao,
        "aria-expanded": this.state.estaAberto
      }, this.state.estaAberto ? textoDoBotaoDeExpansaoAberto : textoDoBotaoDeExpansaoFechado))), children && _react.default.createElement("div", {
        className: "cartao__corpo"
      }, children));
    }
  }]);

  return Cartao;
}(_react.Component);

exports.Cartao = Cartao;
Cartao.propTypes = {
  titulo: _propTypes.default.node,
  subtitulo: _propTypes.default.node,
  cor: _propTypes.default.string,
  icone: _propTypes.default.string,
  containerSecundario: _propTypes.default.node,
  comConteudoExpansivo: _propTypes.default.bool,
  comDestaque: _propTypes.default.bool,
  comCabecalhoResponsivo: _propTypes.default.bool,
  estaAberto: _propTypes.default.bool,
  classNameDoBotaoDeExpansao: _propTypes.default.string,
  textoDoBotaoDeExpansaoFechado: _propTypes.default.node,
  textoDoBotaoDeExpansaoAberto: _propTypes.default.node,
  eventoDoBotaoDeExpansaoAoAbrirCartao: _propTypes.default.func,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};